export const NOT_ENROLLED = 'not-enrolled';
export const VARIATION = 'variation';

export const WHITEBOARDS_EXPAND_JIRAS_EXPERIMENT = 'grw_1037_expand_plan_in_whiteboards';

export const CTA_SOURCE_CONTEXT = 'planOnWhiteboardBacklogButton';
export const CTA_SOURCE_COMPONENT = 'planOnWhiteboardsButtonCTAScreen';

export type Flow = 'none' | 'crossFlow' | 'coUse';

export const DATA_PRIVACY_LINK = 'https://www.atlassian.com/legal/privacy-policy';

export const WHITEBOARD_ENTRYPOINT_EXPERIMENT_VARIANTS = {
	CONTEXT_MENU: 'variant_contextual_menu',
	BACKLOG_BUTTON: 'variant_backlog_button',
	CONTROL: 'control',
} as const;

export type WHITEBOARD_ENTRYPOINT_EXPERIMENT_VARIANTS =
	(typeof WHITEBOARD_ENTRYPOINT_EXPERIMENT_VARIANTS)[keyof typeof WHITEBOARD_ENTRYPOINT_EXPERIMENT_VARIANTS];

export type Key = {
	key: string;
	self: string;
};

export type UserPropertyKeys = {
	keys: Key[];
};

export const USER_PROPERTY_KEY_NAMES = {
	BANNER_DISMISSED: 'whiteboards-backlog-entrypoint-banner-dismissed',
	WHITEBOARDS_BACKLOG_ENTRYPOINT_DISMISSED: 'whiteboards-backlog-entrypoint-dismissed',
} as const;

export type UserPropertyKeyNames =
	(typeof USER_PROPERTY_KEY_NAMES)[keyof typeof USER_PROPERTY_KEY_NAMES];
